import { useState } from 'react'
import Cookies from 'universal-cookie'

const useGovCMSFilterCookie = () => {
  const cookies = new Cookies()
  const industryKey = 'FWO_IndustryCookie'
  const subIndustryKey = 'FWO_SubIndustryCookie'
  const cookieDomain = '.fairwork.gov.au'
  const options = {
    path: '/',
    maxAge: 1000000,
    domain: cookieDomain,
  }

  const [, setItemValue] = useState(() => {
    if (cookies.get(industryKey)) {
      return cookies.get(industryKey)
    }
    return null
  })

  const setIndustryCookie = (value) => {
    setItemValue(value)
    cookies.set(industryKey, value, options)
  }

  const removeIndustryCookie = () => {
    cookies.remove(industryKey)
  }

  const setSubIndustryCookie = (value) => {
    setItemValue(value)
    cookies.set(subIndustryKey, value, options)
  }

  const removeSubIndustryCookie = () => {
    cookies.remove(subIndustryKey)
  }

  return [
    setIndustryCookie,
    setSubIndustryCookie,
    removeIndustryCookie,
    removeSubIndustryCookie,
  ] as const
}

export default useGovCMSFilterCookie
